<!-- 
  ===============================================================================
  Using this component to displaying salesforce configuration all enities as cards.
  Each card contains entity  enable/disable status toggle button and field settings button.
  ===============================================================================
-->
<template>
  <v-dialog
    :value="fieldDialogShow"
    max-width="500px"
    persistent
  >
    <v-card class="pa-3">
      <v-card-title class="justify-center">
        <span class="headline">{{ fieldChangeType }}</span>
      </v-card-title>
      <v-card-text class="py-0">
        <v-form
          v-model="fieldFormValidity"
          @submit.prevent="save"
          ref="fieldForm"
        >
          <v-container class="inputs-container">
            <v-row>
              <v-col cols="12" sm="12" md="12" class="px-0">
                <v-radio-group 
                  v-model= "newField.customField"
                  :disabled="defualtFormField"
                  :label="$t('customer.fieldForm.customField')"  
                  row 
                  required
                >
                  <v-radio :label="$t('customer.fieldForm.true')" :value="true"></v-radio>
                  <v-radio :label="$t('customer.fieldForm.false')" :value="false"></v-radio>
                </v-radio-group>
              </v-col> 
              <!-- FieldName text-field -->
              <v-col cols="12" sm="12" md="12" class="px-0">
                <v-text-field 
                  v-model="newField.fieldName" 
                  :disabled="defualtFormField" 
                  :label="$t('customer.fieldForm.fieldName')" 
                  required
                  :rules="addNewFieldRules.fieldName"
                ></v-text-field>
              </v-col>
               <!-- Field label text-field -->
              <v-col cols="12" sm="12" md="12" class="px-0">
                <v-text-field 
                  v-model="newField.label" 
                  :label="$t('customer.fieldForm.label')" 
                  required
                  :rules="addNewFieldRules.label"
                >
                </v-text-field>
              </v-col>
               <!-- Field data types select box-->
              <v-col cols="12" sm="12" md="12" class="px-0">
                <v-select
                  :items="dataTypeValues"
                  :label="$t('customer.fieldForm.dataType')"
                  v-model="newField.dataType"
                  :persistent-hint="newField.dataType === 'picklist' || (newField.dataType === 'multipicklist' && arrayMultiSelectCheckbox)"
                  :hint="(newField.dataType === 'picklist' || (newField.dataType === 'multipicklist' && arrayMultiSelectCheckbox)) ? dataTypeNote : ''"
                  required
                  :disabled="defualtFormField"
                  :rules="addNewFieldRules.dataType"
                ></v-select>
              </v-col>
              <!-- Picklist combo box -->
              <v-col
                v-if="newField.dataType === 'picklist'"
                class="px-0 pt-2"
                cols="12"
                md="12"
                sm="12"
              >
                <v-combobox
                  v-model="preSelectList"
                  :search-input.sync="search"
                  :rules="[preSelectListRules]"
                  hide-selected
                  hint="Maximum of 10 tags"
                  :label="$t('customer.fieldForm.addTags')"
                  multiple
                  persistent-hint
                  small-chips
                  required
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ $t('customer.fieldForm.noResultMatch') }} "<strong>{{ search }}</strong>". 
                          {{ $t('customer.fieldForm.press') }} <kbd>enter</kbd> {{ $t('customer.fieldForm.toCreateNew') }} 
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>
              </v-col>
              <!-- Multi-picklist combo box without allow pre-define tags-->
              <v-col
                v-if="newField.dataType === 'multipicklist'"
                class="px-0"
                cols="12"
                md="12"
                sm="12"
              >
                <!-- Predefine tags checkbox -->
                <v-checkbox
                  v-model="arrayMultiSelectCheckbox"
                  :label="$t('customer.fieldForm.addMultiSelectList')"
                  persistent-hint
                  :hint="$t('customer.fieldForm.addMultiSelectListTooltip')"
                ></v-checkbox>
              </v-col>
              <!-- Multi-picklist combo box with allow pre-define tags-->
              <v-col
                v-if="arrayMultiSelectCheckbox"
                class="px-0 pt-2"
                cols="12"
                md="12"
                sm="12"
              >
                <v-combobox
                  v-model="preSelectList"
                  v-if="newField.dataType === 'multipicklist' && arrayMultiSelectCheckbox"
                  :search-input.sync="search"
                  :rules="[preSelectListRules]"
                  hide-selected
                  hint="Maximum of 10 tags"
                  :label="$t('customer.fieldForm.addTags')"
                  multiple
                  persistent-hint
                  small-chips
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title>
                          {{ $t('customer.fieldForm.noResultMatch') }} "<strong>{{ search }}</strong>". 
                          {{ $t('customer.fieldForm.press') }} <kbd>enter</kbd> {{ $t('customer.fieldForm.toCreateNew') }} 
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-combobox>

              </v-col>
              <v-col cols="12" sm="12" md="12" class="px-0">
                <v-radio-group  row 
                  :label="$t('customer.fieldForm.required')" 
                  v-model= "newField.required"
                  :disabled="defualtFormField"
                  required
                >
                  <v-radio :label="$t('customer.fieldForm.true')" :value="true"></v-radio>
                  <v-radio :label="$t('customer.fieldForm.false')" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
      <!-- Close and Save action buttons -->
      <v-card-actions class="px-4">
        <v-btn
          @click="fieldDialogClose()"
          class="ma-1"
          color="red darken-1"
          dark
        >{{ $t('cancel') }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!fieldFormValidity"
          @click="fieldSave()"
          class="ma-1"
          color="green darken-1"
          dark
        >{{ $t('save') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  /** 
   @desc Importing required modules 
  */
  import { customerMixin } from '../mixins/customerMixins'
  import i18n from '../i18n';

  export default {
    /**
      * @desc Intalizing passed data from a CustomerEntityDialog.vue component
      * $fieldDialogShow: New field form dialog status
      * fieldData: Contains edit/ new selected field data
    */
    props: {
      fieldDialogShow: {
        required: true,
        type: Boolean
      },
      fieldData: {
        required: false,
        type: Object
      }
    },
    mixins: [customerMixin],
    mounted() {
      console.log(`[SalesforceFieldForm] - mounted...`);
      this.preSelectList = this.initialArray
      //  Edit field
      if (this.fieldData && this.fieldData.fieldName){
        this.newField = JSON.parse(JSON.stringify(this.fieldData))
        console.log(`[SalesforceFieldForm] - mounted - EDIT FIELD - this.newField:`, this.newField);

        if(this.newField.defaultField) this.defualtFormField = true; 

        // Set default fields as readonly
        if(this.newField.default) this.defualtFormField = true;
        // Set preSelectList tags
        if (this.newField.preSelectList &&  this.newField.preSelectList.length > 0) {
          if (this.newField.dataType == 'multipicklist') this.arrayMultiSelectCheckbox = true
          
          this.preSelectList = [...this.newField.preSelectList]
        }
        // Selected field custom field or not
        if(!this.newField.customField) this.$set(this.newField, 'customField', false);

        this.fieldChangeType = i18n.t('customer.fieldForm.edit');

      } 
      // New field
      else {
        this.newField = JSON.parse(JSON.stringify(this.defaultField));
        console.log(`[SalesforceFieldForm] - mounted - NEW FIELD - this.newField:`, this.newField);
      }

      this.addNewFieldRules = this.addFieldRules;
    },
    data () {
      return {
        defualtFormField: false,
        fieldChangeType: i18n.t('customer.fieldForm.new'),
        fieldFormValidity: false,
        addNewFieldRules: {},
        // Data types for entity fields
        dataTypeValues: [   
          {
            text: 'Boolean',
            value: 'boolean'
          },
          {
            text: 'Date',
            value: 'date'
          },
          {
            text: 'Double',
            value: 'double'
          },
          {
            text: 'Int',
            value: 'int'
          },
          {
            text: 'Multipicklist',
            value: 'multipicklist'
          },
          {
            text: 'Picklist',
            value: 'picklist'
          },
          {
            text: 'String',
            value: 'string'
          },
        ],
        // New field object
        newField: {
          customField: false,
          fieldName: '',
          label: '',
          dataType: '',
          required: false,
          preSelectList: []
        },
        // Default field object
        defaultField: {
          customField: false,
          fieldName: '',
          label: '',
          dataType: '',
          required: false,
          preSelectList: []
        },
        arrayMultiSelectCheckbox: false,
        dataTypeNote: i18n.t('customer.fieldForm.pickListHint'),
        preSelectList: [],
        initialArray: [],
      }
    },
    watch: {
      // Watching picklist and multi-picklist tags
      preSelectList: (newVal, oldVal) => {
        const last = newVal[newVal.length - 1]
        if (last){
          const lastLower = last;
          newVal[newVal.length - 1] = lastLower
        }

        if (newVal.length > 10) {
          this.$nextTick(() => this.preSelectList.pop())
        } 
      },
    },
    methods :{
      /**
        * @desc Reset field form validation messages 
      */
      resetFieldFormValidation() {
        this.$refs.fieldForm.resetValidation()
      },
      /**
        * @desc Close field dialog when user click close button
      */
      fieldDialogClose() {
        this.$nextTick(() => {
          this.newField = Object.assign({}, this.defaultField);
          this.editedIndex = -1;
          this.fieldChangeType = i18n.t('customer.fieldForm.new');
        })

        this.$emit('field-dialog-close')
      },
      /**
        * @desc To update selected entity form field details 
        * @returns Emitting event to CustomerEntityDialog.vue component
      */
      fieldSave() {

        if (this.newField.dataType !== 'picklist' && this.newField.dataType !== 'multipicklist') {
          this.$delete(this.newField, 'preSelectList');
        }

        if (this.newField.dataType === 'multipicklist' && !this.arrayMultiSelectCheckbox){
          this.preSelectList = [...[]]
          this.newField.preSelectList = [...[]]
        }

        if (this.preSelectList &&  this.preSelectList.length > 0) {
          this.newField.preSelectList = [...this.preSelectList]
        }

        this.$emit('field-save', this.newField)
      },
      /**
        * @desc Preparing picklist data field rules
        * @returns Binding rules to picklist data field
      */
      preSelectListRules(value) {
        if (value instanceof Array && value.length == 0) {
          return 'Field Tags is required.';
        }
        return !!value || 'Field Tags is required.';
      }
    }
  }
</script>

<style lang="scss" scoped>
  /**
    * @desc Removing padding aroung input fields
  */
  .inputs-container {
    .col-12 {
      padding-top: 0;
      padding-bottom: 0;
    }
    .theme--light.v-input {
      padding-top: 1;
    }
    .v-input__slot {
      margin-bottom: 1;
    }
  }
</style>